import React from 'react'
import ReactDOM from 'react-dom'

import axios from 'axios'
import NumberFormat from 'react-number-format';

import Moment from 'moment'
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

Moment.locale('en-gb');

import Account from './account'
import ProcessButton from '../../shared/process-button'
import TimeSelect from './time-select'
import PriceSelect from './price-select'

import ReactModal from 'react-modal';
ReactModal.setAppElement('body');

// products/show/_ask - the "Got a question before you book?" section
const ASK_SECTION_ID = 'panel6'

const ModalStyles = {
  overlay: {
	  backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content : {
	padding				  : '1rem',
	width				  : 'auto',
	maxWidth			  : '800px',
	height				  : 'auto',
	maxHeight             : '90%',
	top                   : '50%',
	left                  : '50%',
	right                 : 'auto',
	bottom                : 'auto',
	marginRight           : '-50%',
	transform             : 'translate(-50%, -50%)'
  }
};


class Form extends React.Component {

	constructor(props) {

		super(props);

		const messageText = "Hi " + this.props.product.supplier.name + ",\n\nPlease can you let me know if you have availability for the date and time I have requested. Thanks!";

		let defaultDate = null
		let defaultInstantBookStatus = this.props.product.hasInstantBook || this.props.product.hasVendor ? true : false
		if( this.props.defaults.date != null ) {
			defaultDate = this.parseDate( this.props.defaults.date )
			defaultInstantBookStatus = this.instantBookStatus( defaultDate )
		}
		
		this.state = {
			price: this.defaultPrice(),
			showFromPrice:  this.defaultShowFromPrice(),
			formData: {
				pax: this.props.defaults.pax,
				date: defaultDate,
				time: this.props.defaults.time != null ? this.props.defaults.time : '',
				price_id: this.props.defaults.price_id || 0,
				message_text: messageText,
				company_name: '',
			},
			selected_time: '',
			formStatus: {
				step: 0,
				complete: false,
				shake: false,
				shakeField: null
			},
			showAuthModal: false,
			focused: null,
			deposit: false,
			split: false,
			tracked: false,
			instantBook: defaultInstantBookStatus,
			loadMonth: false, 
			availability: false,
			availabilityAlert: false
		}
		
	}
	
	buttonText = ( instantBook ) => {
		return instantBook ? 'Book' : 'Enquire'
	}
	
	instantBookStatus = ( date ) => {
		if( this.props.product.hasVendor ) {
			return true
		} else {
			if( this.props.product.hasInstantBook ) {
				const stopSellDate = Moment(this.props.product.stopSell, 'YYYY-MM-DD').toDate()
				return date > stopSellDate ? true : false
			} else {
				return false
			}
		}
	}

	componentDidMount = () => {
		if( this.state.formData.pax > 0 || this.state.formData.date != null || this.state.formData.time != '' ) {
			this.getFormStatus();
		}
		
		//load availailability for this month
		if( this.props.product.hasVendor ) {
			this.getAvailability( Moment() )
		}
		
		//selected a tier price - so lets reset from price
		if( this.state.formData.pax > 0 && this.props.product.priceType == 3 ) {
			this.getTierPrice()
		}
	}

	//componentDidCatch = ( error, info ) => {
		//error
		//Rollbar.error(error, { level: 'error', extra: info });
	//}

	hasTimePrices = () => {
		return this.props.product.priceType == 2 || this.props.product.priceType == 4 ? true : false;
	}

	hasTimeSet= () => {
		return this.props.product.priceType != 2 && this.props.timeSet && this.props.timeSet.length ? true : false;
	}

	defaultPrice = () => {
		return this.props.defaults.price_id > 0 ? this.props.defaults.price : this.props.product.fromPrice;
	}

	defaultShowFromPrice = () => {
		return this.props.defaults.price_id > 0 ? false : this.props.product.showFromPrice;
	}

	/*
	####################
	##  DATE HELPERS  ##
	####################
	*/

	parseDate = (date) => {
		if( date == null ) {
			return null;
		}
		let objDate = Moment();
		const dateParts = date.split('/');
		objDate.set('year', Number(dateParts[2]) );
		objDate.set('month', Number(dateParts[1])-1 );
		objDate.set('date', Number(dateParts[0]) );
		objDate.set('hour', 4 );
		objDate.set('minute', 0);
		objDate.set('second', 0 );
		objDate.set('millisecond', 0);

		return objDate;
	}

	/*
	####################
	##  FORM HELPERS  ##
	####################
	*/

	//setFormStatusStep only ever raises the step, so the party size going back to
	//"Guests" left Date and Time live with nobody to price for - and a date change
	//from there asks the server for the price of 0 people. Re-derive the whole lock
	//from the form instead, without shaking anything they haven't asked for yet.
	restateFormStatus = () => {
		return Object.assign( this.formValidation(), { shake: false, shakeField: false } )
	}

	setFormStatusStep = ( step ) => {
		const status = this.state.formStatus;
		if( step > this.state.formStatus.step ) {
			status.step = step;
		}
		status.shake = false;
		status.shakeField = false;
		return status;
	}

	getFormStatus = () => {
		const status = this.formValidation();
		this.setState({ formStatus: status });
		return status;
	}

	formValidation = () => {

		const status =  {
			step: 0,
			complete: false,
			shake: true,
			shakeField: false
		}

		//pax
		if( this.formValidPax() ) {
			status.step = 1;
		} else {
			status.step = 0;
			status.shakeField = 'pax';
			return status;
		}

		//date
		if( this.formValidDate() ) {
			status.step = 2;
		} else {
			status.step = 1;
			status.shakeField = 'date';
			return status;
		}

		//time
		if( this.formValidTime() ) {
			status.step = 3;
		} else {
			status.step = 2;
			status.shakeField = 'time';
			return status;
		}

		//no error
		status.complete = true;
		status.shake = false;
		status.shakeField = false;

		//return
		return status;

	}

	formValidPax = () => {

		const min = this.props.product.min > 0 ? this.props.product.min : 0;
		const max = this.props.product.max > 0 ? this.props.product.max : 0;

		if( this.state.formData.pax <= 0 || this.state.formData.pax < min ) {
			return false;
		}

		if( max > 0 && this.state.formData.pax > max ) {
			false;
		}

		return true;
	}

	formValidDate = () => {
		if( this.state.formData.date == null ) {
			return false;
		}
		return true;
	}

	formValidTime = () => {
		if( this.state.formData.time == null || this.state.formData.time.length <= 0 ) {
			return false;
		}
		return true;
	}

	setFormError = ( field ) => {
		return {
			complete: false,
			shake: true,
			shakeField: field
		}
	}

	//Date and Time stay locked until a guest count reaches our state, and a locked
	//field that does nothing when tapped reads as broken. Shake the field they
	//actually need - and let the re-render pull a select that drifted out of step
	//with our state (a change we never heard) back to what we think it is.
	promptForEarlierStep = ( field ) => () => {
		this.setState({
			formStatus: Object.assign( {}, this.state.formStatus, this.setFormError( field ) )
		})
	}

	/*
	##################
	##  PAX SELECT  ##
	##################
	*/

	handlePaxChange = ( event ) => {
		
		if( event.target.value > 0 ) {

			const formData = this.state.formData;
			formData.pax = event.target.value;

			this.setState({
				formData: formData,
				formStatus: this.restateFormStatus(),
				availabilityAlert: false
			}, function() {
				if( this.props.product.priceType == 3 ) {
					this.getTierPrice()
				}
				
				if( this.props.product.hasVendor ) {
					if( this.state.formData.date != null ) {
						this.refs.timeSelect.getTimes();
					} else {
						this.getAvailability( Moment() )	
					}
				}
			});
		} else {

			const formData = this.state.formData;
			formData.pax = 0;

			this.setState({
				formData: formData,
				formStatus: this.restateFormStatus(),
				price: this.defaultPrice(),
				showFromPrice: this.defaultShowFromPrice(),
				availabilityAlert: false
			});
		}

	}
	
	getTierPrice = () => {
		const url = '/products/' + this.props.product.id + '/tier_price';
		axios.post( url, {
				authenticity_token: this.props.token,
				id: this.props.productId,
				pax: this.state.formData.pax
		}).then( response => {
			this.setState({
				price: response.data.price,
				showFromPrice: false
			});
		}).catch(err => {
			this.setState({
				price: this.defaultPrice(),
				showFromPrice: this.defaultShowFromPrice()
			});
		});
	}
	
	
	track = () => {
		if( !this.state.tracked ) {
			this.track_event( 'add_to_cart', this.props.product )
			this.setState({ tracked: true });
		}
		return true
	}
	
	track_event = ( event, product ) => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ ecommerce: null });
		window.dataLayer.push({
		  event: 'add_to_cart',
		  ecommerce: {
			  currency: 'GBP',
			  value: this.state.price,
			  items: [{
				  index: 0,
				  item_id: product.id,
				  item_name: product.name,
				  item_brand: product.supplier_name, 
				  price: this.state.price,
				  quantity: this.state.pax
			  }]
		  }
		 });
	}

	handleDateChange = ( date ) => {

		const formData = this.state.formData;
		formData.date = date;
		
		if( this.props.product.hasVendor ) {
			formData.time = '';
			formData.price_id = 0;
		}
		
		let reopenTimeSelect = true;
		//if( this.hasTimePrices() || this.hasTimeSet() ) {
			//formData.time = '';
			//reopenTimeSelect = true;
		//}
		
		this.setState({
			formData: formData,
			formStatus: this.setFormStatusStep(2),
			price: this.defaultPrice(),
			showFromPrice: this.defaultShowFromPrice(),
			instantBook: this.instantBookStatus( date ),
			availabilityAlert: false

		}, function() {

			//if its a grid, then lets open the time select
			if( reopenTimeSelect ) {
				this.refs.timeSelect.getTimes();
			}

			//CHECK DEPOSIT OPTION IS AVAILABLE
			const url = '/products/' + this.props.product.id + '/deposit';
			axios.post( url, {
					authenticity_token: this.props.token,
					id: this.props.productId,
					date: this.state.formData.date.format('DD/MM/YYYY')
			}).then( response => {
				this.setState({
					deposit: response.data.deposit ? response.data : false,
					split: response.data.split ? true : false
				});
			}).catch(err => {
				this.setState({
					deposit: false,
				});
			});
		});


	}

	startMonth = () => {
		if( this.props.product.priceType == 4 && this.props.availability.length > 0 && this.props.startMonth.length > 0 ) {
			return Moment( this.props.startMonth );
		} else {
			return Moment();
		}
	}
	
	changeMonth = ( date ) => {
		if( this.props.product.hasVendor ) {
			this.getAvailability( date )
		}
	}
	
	getAvailability = ( date ) => {
		this.setState({
			loadMonth: true
		}, function() {
			const url = '/api/v1/products/' + this.props.product.id + '/availability';
			axios.post( url, {
				authenticity_token: this.props.token,
				availability: {
					id: this.props.product.id,
					pax: this.state.formData.pax,
					month: date.format('M'),
					year: date.format('YYYY')
				}
			}).then( response => {
				this.setState({
					availability: response.data,
					loadMonth: false
				});
			}).catch(err => {
				this.setState({
					loadMonth: false
				});
			});
		});
	}

	/*
	###################
	##  TIME SELECT  ##
	###################
	*/

	handleTimeChange = ( timeObj, index ) => {
		if( timeObj ) {
			const formData = this.state.formData;
			formData.time = timeObj.time;
			formData.price_id = timeObj.id;
			this.setState({
				formData: formData,
				selected_time: index,
				formStatus: this.setFormStatusStep(3),
				showFromPrice: false,
				price: timeObj.price,
				availabilityAlert: timeObj.alert ? timeObj.availability : false
			});
		} else {
			const formData = this.state.formData;
			formData.time = '';
			formData.price_id = 0;

			const status = this.state.formStatus;
			status.step = 2;
			status.shake = true;
			status.shakeField = 'time';

			this.setState({ 
				formData: formData,
				selected_time: '',
				formStatus: status,
				showFromPrice: this.defaultShowFromPrice()
			});
		}
	}

	/*
	######################
	##  ENQUIRE BUTTON  ##
	######################
	*/

	enquireButtonStatus = () => {
		return this.state.formStatus.step == 3 ? true : false;
	}

	//ponytail: a browser Back re-renders this page with empty server defaults, so stash the cart
	saveCart = () => {
		try {
			const formData = this.state.formData;
			sessionStorage.setItem( cartKey( this.props.product.id ), JSON.stringify({
				pax: formData.pax,
				date: formData.date.format('DD/MM/YYYY'),
				time: formData.time,
				price_id: formData.price_id,
				price: this.state.price
			}));
		} catch(err) {
			//storage unavailable (private browsing, quota) - never block the booking
		}
	}

	handleClick = ( event, type ) =>  {

		event.preventDefault();

		const formStatus = this.getFormStatus();



		if( formStatus.complete ) {

			this.saveCart()
			this.track()

			//if they are logged in we always submit the form
			if( this.props.status || this.props.product.hasVendor ) {
				this.refs.productForm.submit();
			} else {
				if( this.state.instantBook && type == 'instant-book' ) {
					this.refs.productForm.submit();
				} else {
					//run signin process
					this.setState({ showAuthModal: true });
				}
			}
			
		} else {
			return false;
		}
	}


	/*
	#######################
	##  MODAL FUNCTIONS  ##
	#######################
	*/
	handleCloseModal = () => {
		this.setState({ showAuthModal: false });
	}

	handleBookingInput = (event) =>{
		const formData = this.state.formData;
		formData[event.target.name] = event.target.value;
		this.setState({ formData: formData });
	}

	handleAuthSuccess = ( user ) => {
		this.refs.productForm.submit();
	}

	/*
	########################
	##  RENDER FUNCTIONS  ##
	########################
	*/
	renderMinMax = () => {
		if( this.props.product.min > 0 || this.props.product.max > 0 ) {
			const items = [];
			if( this.props.product.min > 0 ) {
				items.push( '<b>Min:</b> ' + this.props.product.min );
			}

			if( this.props.product.max > 0 ) {
				items.push( '<b>Max:</b> ' + this.props.product.max );
			}
			return {__html: items.join( ', ' ) + ' people'};
		} else {
			return null;
		}
	}
	
	

	render() {
		
		const formErrors = this.props.errors.length ? this.props.errors : false;

		const paxClass = this.state.formStatus.shake && this.state.formStatus.shakeField == 'pax' ? 'input-group guests animated shakeme input_error' : 'input-group guests animated';
		const dateClass = this.state.formStatus.shake && this.state.formStatus.shakeField == 'date' ? 'input-group date animated shakeme input_error' : 'input-group date animated';
		const timeClass = this.state.formStatus.shake && this.state.formStatus.shakeField == 'time' ? 'input-group time animated shakeme input_error' : 'input-group time animated';

		// Checking out creates nothing - CheckoutController#new builds the booking
		// in memory and renders - so the instant-book submit is a GET. A GET
		// carries no CSRF token, which is the whole point: the token baked into
		// this page dies with the session, and a phone that sat on the product
		// page long enough to lose its session cookie was answering Book Now with
		// a 422. Enquiring really does create a record, so that stays a POST.
		const instantBook = this.state.instantBook
		const url = instantBook ? this.props.product.url + `/checkout` : this.props.product.url + `/booking`

		return (
			<form name="productForm" ref="productForm" className="new_booking" id="new_booking" action={url} acceptCharset="UTF-8" method={instantBook ? 'get' : 'post'}>

				{!instantBook ? (
					<>
						<input name="authenticity_token" value={this.props.token} type="hidden" />
						<input name="message_text" value={this.state.formData.message_text} type="hidden" />
					</>
				) : null }
				<input name="utf8" type="hidden" value="&#x2713;" />
				{!this.props.status? (
					<input name="view" value="extended" type="hidden" />
				) : null }
				<input name="booking[product_id]" value={this.props.product.id} type="hidden" />
				<input name="booking[time]" value={this.state.formData.time} type="hidden" />
				<input name="booking[price_id]"value={this.state.formData.price_id} type="hidden" />
				<input name="booking[company_name]" value={this.state.formData.company_name} type="hidden" />


				
				{!this.props.product.hasInstantBook ? (
					<>
						{!this.props.status? (
							<input name="booking[view]" value="extended" type="hidden" />
						) : null }
						<input name="booking[message_text]" value={this.state.formData.message_text} type="hidden" />
						<input name="booking[company_name]" value={this.state.formData.company_name} type="hidden" />
					</>
				): null}

				{ formErrors ?
					<ul>
						{formErrors.map((error, index) => {
							return (
								<li key={`error` + index}>{error}</li>
							)
						})}
					</ul>
					: null
				}


				<p className="text-center pricing" itemProp="offers" itemScope itemType="http://schema.org/Offer">
					{this.state.showFromPrice ? <span className="small-text">from </span> : null }
					<b>
						<span itemProp="priceCurrency" content="GBP">£</span>
						<NumberFormat itemProp="price" content={this.state.price} value={this.state.price} displayType={'text'} thousandSeparator={true} prefix="" decimalScale={2} fixedDecimalScale={true} />
					</b>
					<span className="small-text">
						<span itemProp="priceCurrency" content="GBP"> {this.props.product.fixedPrice ? 'Per group' : 'per person'}</span>
					</span>
				</p>
				{this.props.product.sold_out && <p className="new_booking--sold-out"><span>2024 DATES COMING SOON</span></p> }
				{!this.props.product.sold_out &&
				<>
        		<div className="divider"></div>
				<div className="product-view__product-details--availability clearfix">
					<div className="grid-x grid-margin-x">
						<div className="small-12 cell">
							<p dangerouslySetInnerHTML={this.renderMinMax()} />
						</div>
						<div className="small-12 cell">
							<div className={paxClass}>
								<select name="booking[pax]" value={this.state.formData.pax} onChange={this.handlePaxChange}>
									<option value="0" key="pax-0">Guests</option>
									{this.props.product.paxRange.map((p, index) => {
										return (
											<option key={`pax-` + p} value={p}>{p} people</option>
										)
									})}
								</select>
							</div>
						</div>
						<div className="small-12 cell">
							<div className={dateClass} onClick={ this.state.formStatus.step >= 1 ? undefined : this.promptForEarlierStep('pax') }>
								<SingleDatePicker
									id="booking[date]"
									placeholder={this.state.formStatus.step >= 1 ? 'Date' : 'Select guests first'}
									date={this.state.formData.date}
									onDateChange={this.handleDateChange}
									onFocusChange={({ focused }) =>
										this.setState({ focused })
									}
									focused={this.state.focused}
									isDayHighlighted={(day) => {
										
										//in blackouts?
										if( this.props.blackouts.length > 0 ) {
											if( this.props.blackouts.indexOf( day.format('YYYY-MM-DD') ) != -1 ) {
												return false;
											}
										}
												
										if( this.props.product.hasVendor ) {
											const key = day.format('DD-MM-YYYY')
											return this.state.availability && this.state.availability[key] != undefined && this.state.availability[key] ? true : false
										} else {
											//price type == 2
											if( this.props.product.priceDays.length > 0 ) {
												if( this.props.product.priceDays.indexOf( ( day.isoWeekday() ) ) >= 0 ) {
													return true;
												}
											}
											//if price type is 4 then check if we have the right days
											if( this.props.product.priceType == 4 ) {
												if( this.props.availability.length > 0 ) {
													if( this.props.availability.indexOf( day.format('YYYY-MM-DD') ) >= 0) {
														return true;
													}
												}
											}
											return false
												
										}
									}}
									
									isOutsideRange={(day) => {
										if( day.isBefore( Moment(), "day" ) ) {
											return true;
										} else {
											
											//in blackouts?
											if( this.props.blackouts.length > 0 ) {
												if( this.props.blackouts.indexOf( day.format('YYYY-MM-DD') ) != -1 ) {
													return true;
												}
											}
												
											if( this.props.product.hasVendor ) {
												const key = day.format('DD-MM-YYYY')
												return this.state.availability[key] == undefined || !this.state.availability[key] ? true : false
											} else {
												//can only select a specific day (isoWeekday: day is 1 monday, 7 = sunday)
												if( this.props.product.priceDays.length > 0 ) {
													if( this.props.product.priceDays.indexOf( ( day.isoWeekday() ) ) == -1 ) {
														return true;
													}
												}
												
												//if price type is 4 then check if we have the right days
												if( this.props.product.priceType == 4 ) {
													if( this.props.availability.length > 0 ) {
														if( this.props.availability.indexOf( day.format('YYYY-MM-DD') ) == -1 ) {
															return true;
														}
													}
												}
												return false
											}
										}
									}}
									
									showDefaultInputIcon={true}
									inputIconPosition="after"
									numberOfMonths={1}
									hideKeyboardShortcutsPanel={true}
									readOnly={true}
									displayFormat="DD/MM/YYYY"
									withFullScreenPortal={window.matchMedia("(max-width: 768px)").matches}
									disabled={this.state.formStatus.step >= 1 ? false : true}
									keepOpenOnDateSelect={false}
									onPrevMonthClick={this.changeMonth}
									onNextMonthClick={this.changeMonth}
									renderCalendarInfo={() => this.state.loadMonth ? <CalLoader /> : null}
								 />
							</div>
						</div>

						<div className="small-12 cell">
							<div className={timeClass} onClick={ this.state.formStatus.step >= 2 ? undefined : this.promptForEarlierStep( this.state.formStatus.step >= 1 ? 'date' : 'pax' ) }>
								<TimeSelect
									ref="timeSelect"
									id={this.props.product.id}
									price={this.props.product.fromPrice}
									date={this.state.formData.date}
									pax={this.state.formData.pax}
									time={this.state.formData.time}
									hasTimePrices={this.hasTimePrices()}
									hasTimeSet={this.hasTimeSet()}
									token={this.props.token}
									active={this.state.formStatus.step >= 2 ? true : false}
									value={this.state.selected_time}
									handleTimeChange={this.handleTimeChange}
								/>
							</div>
							{this.state.availabilityAlert ? (
								<div className="availability-alert">Hurry only {this.state.availabilityAlert} places remaining!</div>		
							): null}
						</div>
					</div>

					{this.state.deposit || this.state.split ? <PaymentOption deposit={this.state.deposit} split={this.state.split} /> : null }

					{this.enquireButtonStatus() ? (
						<Buttons 
							canInstantBook={this.state.instantBook}
							hasVendor={this.props.product.hasVendor}
							ttd={this.props.product.ttd}
							handleClick={this.handleClick}
						/>
					) : null}

				</div>


				<ReactModal isOpen={this.state.showAuthModal} contentLabel="Login/Register" style={ModalStyles}>
					<button onClick={this.handleCloseModal} className="close-button" aria-label="Close modal">
						<span aria-hidden="true">×</span>
					</button>
					<Account
						product={this.props.product}
						params={this.state.formData}
						token={this.props.token}
						handleBookingInput={this.handleBookingInput}
						handleAuthSuccess={this.handleAuthSuccess}
					/>
				</ReactModal>
				</>
				}

			</form>
		)
	}
}



const PaymentOption = ({ deposit, split }) => {
	
	//const title = split ? 'Payment options' : 'Deposit Option'
	const refundable = deposit && deposit.non_refundable ? ( <b> non-refundable</b> ) : null;
	const PerPerson = deposit && deposit.fixed && deposit.per_person ? ' per person' : null;
	
	return (
		<div className="grid-x grid-margin-x">
			<div className="small-12 cell">
				<p className="deposit-option-available animated fadeIn">
					<span>Payment options available</span>
					<ul>
					<li>Pay in full now</li>
					{deposit ? ( <li>Pay <b>{deposit.amount}</b>{PerPerson}{refundable} deposit now, rest later</li> ) : null }
					{split ? ( <li>Split the bill with the group.</li>) : null }
					</ul>
				</p>
			</div>
		</div>
	)
}

const Buttons = ({ canInstantBook, hasVendor, ttd, handleClick }) => {
	if( hasVendor ) {
		return (
			<BookButton handleClick={handleClick} />
		)
	} else {
		if( canInstantBook ) {
			return (
				<>
					<p className="available">Good news! We have availability</p>
					<BookButton handleClick={handleClick} />
					{!ttd ? (
						<>
							<p className="more-details">Have further questions?</p>
							<EnquireButton handleClick={handleClick} ttd={ttd} btnClass="box" />
						</>
					) : null }
				</>
			)
		} else {
			return (
				<EnquireButton handleClick={handleClick} ttd={ttd} btnClass="cta" />
			)
		}
	}
	
}

const BookButton = ({ handleClick }) => {
	return (
		<div className="clearfix enquire-btn">
			<ProcessButton
				onClickHandler={(e) => handleClick( e, 'instant-book' )}
				buttonClass="button cta expanded"
				disabled={false}
			>
				Book now!
			</ProcessButton>
		</div>
	)
}

// ponytail: "Make an enquiry" used to submit the widget, and with instant book on
// the widget is aimed at /checkout - so asking a question took the guest to pay.
// A question needs no date, so this jumps to the page's own ask form instead.
//
// On mobile the widget is moved inside the #booking-modal reveal, and while that
// is open Foundation pins the document (html.is-reveal-open is position: fixed),
// so scrolling before it closes does nothing whatsoever. Wait for that class to
// go rather than for Reveal's closed.zf.reveal: close() early-returns without
// firing the event whenever it thinks the modal is already hidden, and Reveal
// puts no class of its own on the modal, so there is nothing on it to test
// either (Foundation's is-open belongs to Dropdown and OffCanvas).
const scrollToAsk = ( event ) => {

	event.preventDefault();

	const ask = document.getElementById( ASK_SECTION_ID );
	if( !ask ) return;

	const html = document.documentElement;
	const pinned = () => html.classList.contains( 'is-reveal-open' );
	const jump = () => ask.scrollIntoView({ behavior: 'smooth', block: 'start' });

	if( !pinned() ) {
		jump();
		return;
	}

	// ponytail: if the modal somehow never closes the observer just sits there and
	// the guest is left looking at it - no worse than the button doing nothing.
	const waitForRelease = new MutationObserver( () => {
		if( pinned() ) return;
		waitForRelease.disconnect();
		jump();
	});
	waitForRelease.observe( html, { attributes: true, attributeFilter: [ 'class' ] });

	if( window.jQuery ) window.jQuery( '#booking-modal' ).foundation( 'close' );
}

const EnquireButton = ({ handleClick, ttd, btnClass }) => {
	return (
		<>
		{ttd ? (
			<p className="unavailable">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
				  <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
				</svg>
				Sorry this date is not available. Please select a different date
			</p>
		) : null }
		<div className="clearfix message-btn">
			<ProcessButton
				onClickHandler={btnClass == 'box' ? scrollToAsk : (e) => handleClick( e, 'enquire' )}
				buttonClass={`button ${btnClass} expanded`}
				disabled={ttd}
			>
				{btnClass == 'box' ? (
					<>
						<img src="/images/svg/message-host.svg" alt="message icon" title="message icon" width="26" />
						<span>Make an enquiry</span>
					</>
				) : (
					<>{ttd ? 'Book now' : 'Check Availability'}</>
				)}
				
			</ProcessButton>
		</div>
		</>
	)
}


const CalLoader = () => {
	const styles = {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		margin: '0',
		padding: '60px 20px 20px 20px'
	}
	const wrapper = {
		backgroundColor: 'white',
		width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',
		zIndex: 3,
		opacity: '0.6' 
		
		
	}
	return (
		<div style={styles}>
			<div style={wrapper}>
				<div className="spinner" />
			</div>
		</div>	
	)
}



const cartKey = ( productId ) => `cart-${productId}`

//the server only renders defaults from @booking or top level params, neither of which survive a
//Back/reload - so fall back to the cart the user had when they last submitted this form
const restoreCart = ( productId, defaults ) => {
	try {
		const saved = sessionStorage.getItem( cartKey( productId ) );
		if( !saved || defaults.pax ) {
			return defaults;
		}
		const cart = JSON.parse( saved );
		//don't resurrect a date that has since gone past
		if( !Moment( cart.date, 'DD/MM/YYYY' ).isSameOrAfter( Moment(), 'day' ) ) {
			return defaults;
		}
		return Object.assign( defaults, cart );
	} catch(err) {
		return defaults;
	}
}


document.addEventListener('DOMContentLoaded', () => {
	const form = document.querySelector('#product-form');

	let product = JSON.parse(form.getAttribute('product'));
	product.showFromPrice = product.showFromPrice == '1' ? true : false;

	const token = form.getAttribute('token');
	const defaults = restoreCart( product.id, JSON.parse(form.getAttribute('defaults') ) );
	const status = form.getAttribute('status') == 'true' ? true : false;
	const errors = JSON.parse(form.getAttribute('errors'));
	const blackouts = JSON.parse(form.getAttribute('blackouts'));
	const availability = JSON.parse(form.getAttribute('availability'));
	const startMonth = form.getAttribute('startMonth');
	const view = form.getAttribute('view');

	/*
	const pax_range = JSON.parse(form.getAttribute('pax_range'));
	const fromPrice = form.getAttribute('fromPrice');
	const showFromPrice = form.getAttribute('showFromPrice') == 'true' ? true : false;
	const min = form.getAttribute('min');
	const max = form.getAttribute('max');
	const grid = form.getAttribute('grid') == 1 ? true : false;
	const productId = form.getAttribute('productId');
	const url = form.getAttribute('url');
	*/


	ReactDOM.render(
		<Form
			product={product}
			token={token}
			defaults={defaults}
			status={status}
			errors={errors}
			blackouts={blackouts}
			availability={availability}
			startMonth={startMonth}
			view={view}
		/>,
		form,
	)
})